module.exports = __webpack_public_path__ + "img/loading5.25ef2804.gif";